import axios, { AxiosError } from 'axios';
import { ErrorCodes, HttpStatus, HttpStatusType } from './httpStatus';
import { BASE_API } from '../contstants/endpoints';
import { toast } from 'react-toastify';

interface IErrorResponse {
  msg?: string;
  error?: string;
  detail?: string;
  message?: string;
}

const handleUnauthorized = (data: IErrorResponse) => {
  const tokenStorage = localStorage.getItem('tokens');
  let tokens = tokenStorage && JSON.parse(tokenStorage);

  fetch(`${BASE_API}/frontend/auth/refresh-token`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      refresh_token: tokens.refresh_token,
    }),
  }).then(refreshResult => {
    if (refreshResult.ok) {
      refreshResult.json().then(tokens => {
        localStorage.setItem('tokens', JSON.stringify(tokens));
        window.location.reload();
      });
    }
  });
};

const handleForbiddenOrNotFound = (status: number, data: IErrorResponse) => {
  if (data.error) {
    console.error(data.error);
  } else if (data.msg) {
    console.error(data.msg);
  }
};

const handleBadRequest = (status: number, data: IErrorResponse) => {
  if (data.detail) {
    toast.error(data.detail);
  }
};

const handleAxiosTimeOut = (data: IErrorResponse) => {
  console.error(data.message ?? 'Timeout');
};

const handleUnknownError = (status: number, data: IErrorResponse) => {
  if (data?.error) {
    console.error(data.error);
  } else if (data?.message) {
    console.error(data.message);
  } else {
    console.error('Server error');
  }
};

export const errorHandler = (error: unknown) => {
  if (axios.isCancel?.(error) || (error as { code?: string })?.code === 'ERR_CANCELED') {
    return;
  }
  if (error instanceof AxiosError) {
    const errorResponse = error.response;

    const errorHandlerError = errorResponse?.data;

    const errorStatus = (errorResponse?.status as HttpStatusType) || HttpStatus.InternalServerError;

    if (!errorHandlerError) {
      return handleUnknownError(HttpStatus.InternalServerError, errorHandlerError);
    }

    const handlers = {
      [HttpStatus.Unauthorized]: () => handleUnauthorized(errorHandlerError),
      [HttpStatus.Forbidden]: () =>
        handleForbiddenOrNotFound(HttpStatus.Forbidden, errorHandlerError),
      [HttpStatus.NotFound]: () =>
        handleForbiddenOrNotFound(HttpStatus.NotFound, errorHandlerError),
      [HttpStatus.InternalServerError]: () =>
        handleUnknownError(HttpStatus.InternalServerError, errorHandlerError),
      [HttpStatus.NotAllowed]: () => handleBadRequest(HttpStatus.NotAllowed, errorHandlerError),
      [HttpStatus.BadRequest]: () => handleBadRequest(HttpStatus.BadRequest, errorHandlerError),
      [ErrorCodes.ECONNABORTED]: () => handleAxiosTimeOut(errorHandlerError),
    };

    const handler = handlers[errorStatus];
    if (typeof handler === 'function') {
      handler();
    } else {
      handleUnknownError(HttpStatus.InternalServerError, errorHandlerError);
    }
  } else {
    console.log('server error');
  }
};
